import React from 'react';
import { Input } from './ui/input';
import { Label } from './ui/label';

export const ClientInfoForm = ({ clientInfo, setClientInfo }) => {
  const handleChange = (field, value) => {
    setClientInfo(prev => ({ ...prev, [field]: value }));
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div className="space-y-2">
        <Label htmlFor="firstName" className="text-sm font-medium">
          First Name <span className="text-destructive">*</span>
        </Label>
        <Input
          id="firstName"
          value={clientInfo.firstName}
          onChange={(e) => handleChange('firstName', e.target.value)}
          placeholder="John"
          className="border-input focus:border-primary focus:ring-primary/20"
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="lastName" className="text-sm font-medium">
          Last Name <span className="text-destructive">*</span>
        </Label>
        <Input
          id="lastName"
          value={clientInfo.lastName}
          onChange={(e) => handleChange('lastName', e.target.value)}
          placeholder="Smith"
          className="border-input focus:border-primary focus:ring-primary/20"
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="phone" className="text-sm font-medium">Phone</Label>
        <Input
          id="phone"
          type="tel"
          value={clientInfo.phone}
          onChange={(e) => handleChange('phone', e.target.value)}
          placeholder="(203) 555-1234"
          className="border-input focus:border-primary focus:ring-primary/20"
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="email" className="text-sm font-medium">Email</Label>
        <Input
          id="email"
          type="email"
          value={clientInfo.email}
          onChange={(e) => handleChange('email', e.target.value)}
          placeholder="john.smith@email.com"
          className="border-input focus:border-primary focus:ring-primary/20"
        />
      </div>
    </div>
  );
};

export default ClientInfoForm;